import * as HLF from "html-living-framework";
import * as AssetHelpers from "../core/AssetHelpers";
import {HoverableButton, TextureButton} from "../core/Button";
import {Callback, Mix} from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import { LightsOutObjectType } from "../data/LightsOutObjectType";
import {TrashType} from "../data/TrashType";
import { GlowFilter } from "../filters/GlowFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { Button } from "./Button";
import { LightsOutObject } from "./LightsOutObject";

export class StaticLightsOutObject extends LightsOutObject {

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        if (typeof texture === "string") {
            this.name = texture.replace(/\.png$/, "");
        }
        super.setLayoutTexture(texture, anchorX, anchorY);
    }

    public onLayout() {
        super.onLayout();
    }

    public TurnOn(pOptions: {animate: boolean} = {animate: true}): void {
        super.TurnOn(pOptions);
        let onTexture = AssetHelpers.texture(this.name + "-on.png");
        if (onTexture === undefined) {
            onTexture = AssetHelpers.texture(this.name.toLowerCase() + "-on.png");
        }
        if (onTexture !== undefined) {
            this.sprite.setLayoutTexture(onTexture, this.sprite.anchor.x, this.sprite.anchor.y);
        }
        else {
            console.error(this.name + "-on.png");
        }
    }

    public TurnOff(pOptions?: {animate: boolean}): void {
        super.TurnOff(pOptions);
        let offTexture = AssetHelpers.texture(this.name + ".png");
        if (offTexture === undefined) {
            offTexture = AssetHelpers.texture(this.name.toLowerCase() + ".png");
        }
        if (offTexture !== undefined) {
            this.sprite.setLayoutTexture(offTexture, this.sprite.anchor.x, this.sprite.anchor.y);
        }
        else {
            console.error(this.name + ".png");
            this.sprite.tintTo(0x999999, 1);
        }
    }
}
